/* eslint-disable array-callback-return */
import React, { useRef, useState, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { AiOutlineSearch, AiOutlineCloseCircle } from "react-icons/ai";
import Input from "../../components/form/Input";
import { authPostRequest } from "../../utils/authGetRequest";
import { useAppContext } from "../../context/state";
import TableOverlay from "../../components/tableoverlay/TableOverlay";
import { useEffect } from "react";
import Link from "next/link";
import { AppContext } from "../../context/state";

const checkSvg = (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3334 1L5.00008 8.33333L1.66675 5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FirstScreen = ({
  setScreen,
  parameters,
  authToken,
  cookies,
  manuallyReset,
  setManuallyReset,
  user,
  uniqUserId,
}) => {
  const { store } = useContext(AppContext);
  const [userName, setUserName] = useState(null);
  const [disableSelect, setDisableSelect] = useState(false);
  const [selectedParamCategory, setSelectedParamCategory] = useState("SQ Ratings");
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchedParameters, setSearchedParameters] = useState([]);
  const [domLoaded, setDomLoaded] = useState(false);
  useEffect(() => {
    setDomLoaded(true);
  }, []);

  const searchInputRef = useRef(null);

  const handleInputChange = (e) => {
    if (e.target.value.length > 0) {
      setSearchedParameters(
        parameters.filter((parameter) => parameter["Display Name"].toLowerCase().includes(e.target.value.toLowerCase()))
      );
    }

    if (!e.target.value) {
      setSearchedParameters([]);
    }
  };

  useEffect(() => {
    if (window.localStorage) {
      setSelectedItems(localStorage.getItem("models")?.split(",") || []);
      if (localStorage.getItem("manuallyReset") === "true") {
        setManuallyReset(true);
      }
    }
  }, []);

  const clearSearch = () => {
    setSearchedParameters("");
    searchInputRef.current.value = "";
  };
  const counts = {};
  if (searchedParameters.length > 0) {
    searchedParameters.map(function (x) {
      counts[x.Category] = (counts[x.Category] || 0) + 1;
    });
  } else {
    parameters.map(function (x) {
      counts[x.Category] = (counts[x.Category] || 0) + 1;
    });
  }

  const result = Object.keys(counts).map((key) => [key, counts[key]]);

  useEffect(() => {
    if (selectedItems.length > 32) {
      setDisableSelect(true);
    } else {
      setDisableSelect(false);
    }
  }, [selectedItems]);

  const setNewItem = (name) => {
    if (selectedItems.length < 32) {
      let array = [...selectedItems, name];
      setSelectedItems(array);
      setDisableSelect(false);
    } else {
      setDisableSelect(true);
    }
  };

  useEffect(() => {
    setUserName(cookies.name);
  }, [cookies]);

  const handleDeselect = (value) => {
    setSelectedItems(selectedItems.filter((item) => item !== value));
  };

  const createModel = async () => {
    if (domLoaded) {
      const data = {
        params: selectedItems,
      };

      if (user) {
        authPostRequest(`/api/${store.leagueType}/model-sandbox/model/create`, authToken, data)
          .then(() => {
            localStorage.setItem("models", Array(selectedItems));
            setManuallyReset(false);
            localStorage.setItem("manuallyReset", false);
            setScreen("second");
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        fetch(
          `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${store.leagueType}/model-sandbox/model/create/${uniqUserId}/unprotected`,
          {
            method: "post",
            body: JSON.stringify(data),
          }
        )
          .then(() => {
            localStorage.setItem("models", Array(selectedItems));
            setManuallyReset(false);
            localStorage.setItem("manuallyReset", false);
            setScreen("second");
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  };

  const resetHandler = () => {
    setSelectedItems([]);
    setDisableSelect(false);
    localStorage.removeItem("models");
    localStorage.setItem("manuallyReset", false);
    setManuallyReset(false);
  };

  useEffect(() => {
    if (domLoaded && user && !manuallyReset && selectedItems.length >= 8 && selectedItems.length < 32) {
      let data = {
        params: selectedItems,
      };
      authPostRequest(`/api/${store.leagueType}/model-sandbox/model/create`, authToken, data)
        .then(() => {
          setScreen("second");
        })
        .catch((err) => {
          console.error(err);
        });
    }
    /// comeback here
  }, [domLoaded, manuallyReset]);

  return (
    <>
      <section className="header-secondary">
        <div className="container-fluid">
          <h2>Model Sandbox</h2>
          <p>Make your model by selecting from the parameters on the left below</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-7" style={{ borderRight: "1px solid #D0D2D9" }}>
              <div className="d-flex">
                <span className="parameters">All parameters</span>

                <Input
                  icon={<AiOutlineSearch />}
                  placeholder="Search parameters"
                  className="form-control w-100 parameters"
                  ref={searchInputRef}
                  onInput={handleInputChange}
                  rightIcon={
                    searchInputRef?.current?.value.length > 0 ? <AiOutlineCloseCircle onClick={clearSearch} /> : null
                  }
                />
              </div>

              <div className="d-flex categories">
                {result.map((category) => {
                  if (category[0] !== "NOT AN OPTION")
                    return (
                      <button
                        key={uuidv4()}
                        className={selectedParamCategory === category[0] ? "active" : "inactive"}
                        onClick={() => setSelectedParamCategory(category[0])}
                      >
                        {category[0]} ({category[1]})
                      </button>
                    );
                })}
              </div>
              <div className="tags">
                {searchedParameters.length > 0 ? (
                  <>
                    {searchedParameters
                      .filter((param) => param.Category === selectedParamCategory)
                      .map((tag) => {
                        if (!selectedItems.includes(tag["Display Name"])) {
                          return (
                            <button
                              key={uuidv4()}
                              className="tag"
                              disabled={disableSelect}
                              onClick={() => {
                                setNewItem(tag["Display Name"]);
                              }}
                            >
                              {tag["Display Name"]}
                            </button>
                          );
                        }
                      })}
                  </>
                ) : (
                  <>
                    {parameters
                      .filter((param) => param.Category === selectedParamCategory)
                      .map((tag) => {
                        if (!selectedItems.includes(tag["Display Name"])) {
                          return (
                            <button
                              key={uuidv4()}
                              className="tag"
                              disabled={disableSelect}
                              onClick={() => {
                                setNewItem(tag["Display Name"]);
                              }}
                            >
                              {tag["Display Name"]}
                            </button>
                          );
                        }
                      })}
                  </>
                )}
              </div>
            </div>
            <div className="col-md-5 pl-5">
              <div className="d-flex justify-content-between">
                <span className="parameters">
                  <span
                    style={
                      selectedItems.length < 8 || selectedItems.length > 32 ? { color: "red" } : { color: "#208502" }
                    }
                  >
                    {selectedItems.length}
                  </span>
                  /32 selected
                </span>{" "}
                <button
                  style={{
                    background: "transparent",
                    border: 0,
                    color: "#0F131B",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                  onClick={() => {
                    resetHandler();
                  }}
                >
                  Reset All
                </button>
              </div>
              <div className="selectedTags">
                {selectedItems.map((tag) => (
                  <button onClick={() => handleDeselect(tag)} key={uuidv4()} className="selectedTag">
                    {checkSvg} {tag}
                  </button>
                ))}
                {[...Array(32 - selectedItems.length)].map((e, i) => (
                  <span key={uuidv4()} className="emptyTag" />
                ))}
              </div>
              <button
                disabled={selectedItems.length < 8 || selectedItems.length > 32}
                className="btn btn-secondary d-flex"
                style={{ padding: "16px 46px", margin: "146px auto auto auto" }}
                onClick={() => createModel()}
              >
                Create Model
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FirstScreen;
